function Container() {
  return (
    <div className="text-black flex bg-white flex-col pt-[56px] md:pt-[60px] w-full h-full overflow-auto">
      <div className="flex-1 bg-[#F9F4F0] flex w-full justify-center items-center">
        <div className="px-6 flex flex-col gap-5 items-center max-w-2xl py-14">
          <p className="text-center font-klarheit tracking-tight font-semibold text-[64px] leading-[80px]">
            Unlocking Powerful Business Insights
          </p>
          <p className="text-xl text-palette-burgundy font-medium tracking-tight text-center leading-8">
            Your Gateway to Data-driven Success
          </p>
        </div>
      </div>
    </div>
  );
}

export default Container;
